module.exports = "/assets/packs/images/239a1667a400e509d537f532156cd3e6.png";